module.exports = __webpack_public_path__ + "images/uni-global-3419b358f1fe4e95cf62f6be6457899b.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/uni-global.png
// module id = 57
// module chunks = 0